import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';

import { SupplierAuthService } from '../../../../core/services/supplier-auth.service';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [CommonModule, DropdownComponent],
})
export class UserDropdownComponent {
  private auth = inject(SupplierAuthService);

  isOpen = false;
  session = this.auth.session;
  displayName = computed(() => {
    const session = this.session();

    return session?.supplierName || this.emailName(session?.supplierEmailAddress) || 'Supplier';
  });
  email = computed(() => this.session()?.supplierEmailAddress || '');

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  logout() {
    this.closeDropdown();
    this.auth.logout();
  }

  private emailName(email: string | null | undefined) {
    return email?.split('@')[0] ?? '';
  }
}
